import { FC, HTMLAttributes } from 'react';
import { merge } from '../../utils/utility';

export const PageSizer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return <div className={merge(className, 'max-w-7xl mx-auto px-10')}>{children}</div>;
};
